module.exports = __webpack_public_path__ + "assets/img/chartCard-down.54c5309e.svg";